export function BotaoFlutuanteWhatsApp() {
  return (
    <a
      href="https://wa.me/5519998028779?text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20o%20Lizzi%20Food."
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '24px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        background: '#25D366',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 20px rgba(0,0,0,0.25)',
        zIndex: 1000,
      }}
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff" aria-hidden="true">
        <path d="M16.04 3C9.37 3 3.96 8.4 3.96 15.06c0 2.24.62 4.34 1.7 6.14L4 29l7.98-1.6a12.9 12.9 0 0 0 4.06.66c6.67 0 12.08-5.4 12.08-12.06C28.12 8.4 22.7 3 16.04 3zm0 21.97c-1.9 0-3.68-.51-5.2-1.4l-.37-.22-4.73.95.96-4.6-.24-.38a9.86 9.86 0 0 1-1.55-5.28c0-5.46 4.46-9.9 9.94-9.9 5.47 0 9.93 4.44 9.93 9.9 0 5.47-4.46 9.93-9.94 9.93zm5.44-7.44c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.07-.3-.15-1.24-.46-2.37-1.47-.87-.78-1.46-1.74-1.63-2.04-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.18-.24-.58-.48-.5-.66-.5h-.56c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.87 1.22 3.07c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
}
